import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import React, { useEffect, useState } from 'react';
import relationships from 'Consts/Relationships';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import View from './View';

const BANK_ACCOUNT = 'bank_account';
const NON_RETIREMENT_ACCOUNT = 'non_retirement_account';
const EMPLOYER_SPONSORED_PLAN = 'employer_sponsored_plan';
const PERSONAL_RETIREMENT_ACCOUNT = 'personal_retirement_account';
const HEALTH_SAVINGS_ACCOUNT = 'health_savings_account';

const Controller = () => {
  const { householdResource } = useSimpleHousehold();
  const [accountsCollection, setAccountsCollection] = useState();


  const getAccountsOfType = (accountType) => {
    if (!accountsCollection) {
      return [];
    }
    const result = accountsCollection.resources().list().filter(account => account.attr('accountType') === accountType);
    return result !== undefined ? result : [];
  };

  const refreshAccounts = () => {
    return householdResource.relationship(relationships.accounts).link('related').get()
      .then((newAccountsCollection) => {
        newAccountsCollection.fetchAllPages().then(col => setAccountsCollection(col));
      });
  };

  useEffect(() => {
    if (householdResource !== undefined) {
      refreshAccounts()
        .catch(err => displayErrorMessage(err, err.errors));
    }
  }, [householdResource]);

  return (
    <View
      bankAccounts={getAccountsOfType(BANK_ACCOUNT)}
      nonRetirementAccounts={getAccountsOfType(NON_RETIREMENT_ACCOUNT)}
      personalRetirementAccounts={getAccountsOfType(PERSONAL_RETIREMENT_ACCOUNT)}
      employerSponsoredPlans={getAccountsOfType(EMPLOYER_SPONSORED_PLAN)}
      healthSavingsAccounts={getAccountsOfType(HEALTH_SAVINGS_ACCOUNT)}
    />
  );
};
Controller.propTypes = {
};

export default Controller;
